import React, { useContext } from "react";
import { FcGoogle } from "react-icons/fc";
import Wosenderabout from "../../../../images/LandingPageImage/whatsapp_campaign_1x.webp";
import "../designcss/Wosenderaboutenable.css";
import { Link } from "react-router-dom";
import MyContext from "../../../../MyContext";

const Whatsapp = () => {
  const { openFreeTrialModal } = useContext(MyContext)
  return (
    <>
      <div className="about-hero-container">
        <div className="leftsidecontent">
          <span className="businessgrow">The Smart Way to Reach,</span>
          <span className="usingwhatsapp">Engage,</span>
          <span className="marketingservice">and Convert Customers</span>

          <p className="paracontent">
            In today’s fast-paced digital world, businesses need communication
            channels that are instant, personal, and high-converting. Among all
            platforms, WhatsApp marketing has emerged as one of the most
            effective tools for connecting with customers in real time.
          </p>

          <div className="buttons">
             <Link to="/login" className="text-decoration-none">
                      
            <button className="googlebtn">
              <FcGoogle /> Start With Google
            </button>
            </Link>
            <button onClick={openFreeTrialModal} className="demobtn">Book a Demo</button>
          </div>
        </div>

        <div className="rightsideimg">
          <img src={Wosenderabout} alt="" className="homescreen" />
        </div>
      </div>
    </>
  );
};

export default Whatsapp;
